import(/* webpackMode: "eager" */ "/vercel/path0/app/course/page.tsx");
